<template>
  <fieldset class="tab tab-01 none-bg">
    <div class="heading-form a-center">
      <span class="number">1/18</span>
      <p class="c-yellow">ข้อมูลด้านสุขภาพ</p>
      <h2 class="heading-h2 c-white">ข้อมูลพื้นฐาน</h2>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input h-txtlast">
            <label for="" class="icw-label overlabel"
              >น้ำหนัก<span class="c-star"><sup>*</sup></span></label
            >
            <InputPattern
              id="txtWeight"
              type="text"
              :class="{ 'input-required': !weight && isError }"
              v-model="weight"
              @blur="checkWeight()"
              maxlength="3"
              :regExp="/^[0\D]*|\D*/g"
              pattern="\d*"
            />
            <label for="" class="icw-label overlabel txt-last">กก.</label>
            <p class="input-note c-remark" v-if="!(!weight && isError)">
              ระบุได้ตั้งแต่ 30 - 200
            </p>
            <p class="input-note c-red" v-if="!weight && isError">โปรดระบุ</p>
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input h-txtlast">
            <label for="" class="icw-label overlabel"
              >ส่วนสูง<span class="c-star"><sup>*</sup></span></label
            >
            <InputPattern
              id="txtHeight"
              type="text"
              :class="{ 'input-required': !height && isError }"
              v-model="height"
              @blur="checkHeight()"
              maxlength="3"
              :regExp="/^[0\D]*|\D*/g"
              pattern="\d*"
            />
            <label for="" class="icw-label overlabel txt-last">ซม.</label>
            <p class="input-note c-remark" v-if="!(!height && isError)">
              ระบุได้ตั้งแต่ 120 - 220
            </p>
            <p class="input-note c-red" v-if="!height && isError">โปรดระบุ</p>
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox" id="rdoPressure">
            <label class="icw-label overlabel a-left"
              >ค่าความดันโลหิตครั้งล่าสุด<span class="c-star"
                ><sup>*</sup></span
              ></label
            >
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="pressure"
                id="pressure"
                class="css-checkbox more-pressure"
                value="more"
                v-model="pressure"
              />
              <label for="pressure" class="css-label"
                >{{ pressure_up != "" ? pressure_up : "ระบุ ค่าบน" }} /
                {{ pressure_down != "" ? pressure_down : "ค่าล่าง" }}</label
              >
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="pressure"
                id="npressure"
                class="css-checkbox"
                value="-1"
                v-model="pressure"
              />
              <label for="npressure" class="css-label">ไม่แน่ใจ</label>
            </div>
          </div>
        </li>
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox" id="rdoHeartRate">
            <label class="icw-label overlabel a-left"
              >อัตราการเต้นของหัวใจ<span class="c-star"
                ><sup>*</sup></span
              ></label
            >
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="Heart"
                id="heart"
                class="css-checkbox more-heartrate"
                value="more"
                v-model="heartrate"
              />
              <label for="heart" class="css-label"
                >{{ heartrate_num != "" ? heartrate_num : "ระบุ" }} ครั้ง /
                นาที</label
              >
            </div>
            <div class="checkbox checkbox-default">
              <input
                type="radio"
                name="Heart"
                id="nheart"
                class="css-checkbox"
                value="-1"
                v-model="heartrate"
              />
              <label for="nheart" class="css-label">ไม่แน่ใจ</label>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <button
      id="btnNextStepQ2"
      type="button"
      name="next"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>

    <a href="#popup-pressure" class="popup-pressure" style="display: none;"
      >click me</a
    >
    <div id="popup-pressure" class="mfp-hide modal-input modal-bath">
      <div class="modal-content">
        <div class="tb">
          <div class="tbcell v-middle">
            <div class="icw-form">
              <fieldset>
                <div>
                  <h3 class="heading-h3">ค่าความดันโลหิต</h3>
                </div>
                <div class="icw-fieldset-inner">
                  <ul class="icw-fields">
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-left">
                        <InputPattern
                          id="txtPressureUp"
                          type="text"
                          placeholder="ค่าบน"
                          name="pressure_up"
                          v-model="pressure_up"
                          maxlength="3"
                          :regExp="/^[0\D]*|\D*/g"
                          pattern="\d*"
                        />
                        <label for="" class="icw-label overlabel"
                          >มม.ปรอท</label
                        >
                      </div>
                    </li>
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-left">
                        <InputPattern
                          id="txtPressureDown"
                          type="text"
                          placeholder="ค่าล่าง"
                          name="pressure_down"
                          v-model="pressure_down"
                          maxlength="3"
                          :regExp="/^[0\D]*|\D*/g"
                          pattern="\d*"
                        />
                        <label for="" class="icw-label overlabel"
                          >มม.ปรอท</label
                        >
                      </div>
                    </li>
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-center">
                        <button
                          id="btnSubmitPressure"
                          type="button"
                          class="btn btn-th"
                          @click="ConfPressure()"
                        >
                          ตกลง
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a href="#popup-heart" class="popup-heart" style="display: none;"
      >click me</a
    >
    <div id="popup-heart" class="mfp-hide modal-input modal-bath">
      <div class="modal-content">
        <div class="tb">
          <div class="tbcell v-middle">
            <div class="icw-form">
              <fieldset>
                <div>
                  <h3 class="heading-h3">อัตราการเต้นของหัวใจ</h3>
                </div>
                <div class="icw-fieldset-inner">
                  <ul class="icw-fields">
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-left">
                        <InputPattern
                          id="txtHeartRatePerMinute"
                          type="text"
                          name="heartrate_num"
                          placeholder="โปรดระบุ"
                          v-model="heartrate_num"
                          maxlength="3"
                          :regExp="/^[0\D]*|\D*/g"
                          pattern="\d*"
                        />
                        <label for="" class="icw-label overlabel"
                          >ครั้ง / นาที</label
                        >
                      </div>
                    </li>
                    <li class="icw-field icw-field-full">
                      <div class="icw-input a-center">
                        <button
                          id="btnSubmitHeartRate"
                          type="button"
                          class="btn btn-th"
                          @click="ConfHearrate()"
                        >
                          ตกลง
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
import Vue from "vue";

/* jQuery */
import jQuery from "jquery";
/* jQuery */

import InputPattern from "vue-pattern-input";

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep } from "@/helpers/step_helper.js";
window.jQuery = window.$ = jQuery;
require("@/assets/theme/plugin/magnific-popup/jquery.magnific-popup.js");

export default {
  name: "QuestionStep3_Q1",
  components: {
    InputPattern
  },
  props: {
    QuestionType: String
  },
  mounted() {
    this.$nextTick(() => {
      $(".popup-pressure").magnificPopup({
        type: "inline",
        midClick: true,
        removalDelay: 150,
        mainClass: "mfp-fade",
        fixedContentPos: true
      });

      $(".popup-heart").magnificPopup({
        type: "inline",
        midClick: true,
        removalDelay: 150,
        mainClass: "mfp-fade",
        fixedContentPos: true
      });

      $(".more-pressure").click(function() {
        $(".popup-pressure").trigger("click");
      });

      $(".more-heartrate").click(function() {
        $(".popup-heart").trigger("click");
      });

      let self = this;

      $(".popup-pressure").on("mfpClose", function() {
        if (
          $("*[name=pressure_up]").val() == "" &&
          $("*[name=pressure_down]").val() == ""
        ) {
          self.pressure = null;
          $("*[name=pressure]").prop("checked", false);
        }
      });

      $(".popup-heart").on("mfpClose", function() {
        if ($("*[name=heartrate_num]").val() == "") {
          $("*[name=Heart]").prop("checked", false);
        }
      });
    });
  },
  data() {
    return {
      weight: my_storage(this.QuestionType, "weight"),
      height: my_storage(this.QuestionType, "height"),
      pressure: my_storage(this.QuestionType, "pressure"),
      heartrate: my_storage(this.QuestionType, "heartrate"),
      pressure_up: my_storage(this.QuestionType, "pressure_up"),
      pressure_down: my_storage(this.QuestionType, "pressure_down"),
      heartrate_num: my_storage(this.QuestionType, "heartrate_num")
    };
  },
  methods: {
    my_storage,
    nextStep,
    checkWeight() {
      this.$nextTick(() => {
        if (this.weight < 30) this.weight = 30;
        if (this.weight > 200) this.weight = 200;
      });
    },
    checkHeight() {
      this.$nextTick(() => {
        if (this.height < 120) this.height = 120;
        if (this.height > 220) this.height = 220;
      });
    },
    beforeNextStep() {
      let pass = false;

      if (this.weight != "" && this.height != "") {
        if (
          this.pressure != "" &&
          this.pressure != null &&
          this.pressure == "-1"
        ) {
          pass = true;
        } else if (
          this.pressure != "" &&
          this.pressure != null &&
          this.pressure == "more" &&
          this.pressure_up != "" &&
          this.pressure_down != ""
        ) {
          pass = true;
        } else {
          pass = false;
        }

        if (
          pass &&
          this.heartrate != "" &&
          this.heartrate != null &&
          this.heartrate == "-1"
        ) {
          pass = true;
        } else if (
          pass &&
          this.heartrate != "" &&
          this.heartrate == "more" &&
          this.heartrate_num != ""
        ) {
          pass = true;
        } else {
          pass = false;
        }
      }

      if (pass) {
        let check = my_storage("Healthy", "healthy");
        if (check.indexOf("exercise") == -1) {
          sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));
          this.isError = false;
          this.nextStep("tab-01", "tab-04");
        } else {
          sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data));
          this.isError = false;
          this.nextStep("tab-01", "tab-02");
        }
        // if (check.length == 1 && check.indexOf('-1') > -1 ) {
        //   sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data))
        //   this.isError = false
        //   this.nextStep('tab-01', 'tab-04')
        // }else if( check.length != 1 && check.indexOf('-1') == -1 ){

        // } else {
        //   sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data))
        //   this.isError = false
        //   this.nextStep('tab-01', 'tab-02')
        // }
      } else {
        this.isError = true;
      }
    },
    ConfPressure() {
      if (this.pressure_up != "" && this.pressure_down != "") {
        $.magnificPopup.close();
      }
    },
    ConfHearrate() {
      if (this.heartrate_num != "") {
        $.magnificPopup.close();
      }
    }
  },
  computed: {
    isPass() {
      let pass = false;

      if (this.weight != "" && this.height != "") {
        if (
          (this.pressure != "" || this.pressure != null) &&
          this.pressure == "-1"
        ) {
          pass = true;
        } else if (
          (this.pressure != "" || this.pressure != null) &&
          this.pressure == "more" &&
          this.pressure_up != "" &&
          this.pressure_down != ""
        ) {
          pass = true;
        } else {
          pass = false;
        }

        if (pass && this.heartrate != "" && this.heartrate == "-1") {
          pass = true;
        } else if (
          pass &&
          this.heartrate != "" &&
          this.heartrate == "more" &&
          this.heartrate_num != ""
        ) {
          pass = true;
        } else {
          pass = false;
        }
      }

      return pass;
    }
  }
};
</script>
